const initialState = {
    resultsDestinationsList: [],
    resultsDestinationGet: [],
    resultsDestinationsDelete: {},
    resultsDestinationsUpdate: {},
    resultsDestinationsAdd: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "LIST_DESTINATIONS_SGW_RESPONSE_GET":
            newState.resultsDestinationsList = action.value;
            break;
        case "LIST_DESTINATIONS_RESPONSE_GET":
            newState.resultsDestinationGet = action.value;
            break;
        case "DESTINATION_RESPONSE_DELETE":
            newState.resultsDestinationsDelete = action.value;
            break;
        case "DESTINATION_RESPONSE_UPDATE":
            newState.resultsDestinationsUpdate = action.value;
            break;
        case "DESTINATION_RESPONSE_ADD":
            newState.resultsDestinationsAdd = action.value;
            break;

        case "DESTINATIONS_RESPONSE_RESET":
            newState.resultsDestinationsList = [];
            newState.resultsDestinationGet = [];
            newState.resultsDestinationsDelete = {};
            newState.resultsDestinationsUpdate = {};
            newState.resultsDestinationsAdd = {};
            break;

        // case "RESET_DESTINATIONS_RESPONSES":
        //     break;
        default:
            break;
    }
    return newState;
};

export default reducer;
